<p-toast></p-toast>

<div class="grid mx-3">
  <div class="col-12">
    <p-table [value]="letters"
             dataKey="id"
             styleClass="datatable-sm"
             [scrollable]="true"
             scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Letter Type</th>
          <th>Date Sent</th>
          <th>Response Date</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-donorLetterItem>
        <tr>
          <td>{{ donorLetterItem.letterType }}</td>
          <td>{{ donorLetterItem.dateSent | date : 'M/d/yyyy' }}</td>
          <td>{{ donorLetterItem.responseReceivedDate | date : 'shortDate' }}</td>
          <td>
            <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" (clickHandler)="onEditLetterClick(donorLetterItem.letterTypeId)" [disabled]="isReadOnlyMode" />
            <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" [classes]="['table-action-btn']" (clickHandler)="onDeleteLetter(donorLetterItem.letterTypeId)" [disabled]="isReadOnlyMode" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" *ngIf="letters?.length === 0">
        <tr>
          <td [attr.colspan]="4" style="text-align: center;">
            There are no letters for this donation.
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-content-end mt-2">
      <rc-generic-button label="Add New Letter" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="onAddLetterClick()" [disabled]="isReadOnlyMode" />
    </div>
  </div>
</div>


<!-- Add PrimeNG confirmation dialog -->
<p-confirmDialog></p-confirmDialog> 

<!-- Add Donation Letter MODAL -->
<div id="add-donation-letter-card" data-cy="add-donation-letter-card">
    <p-dialog header="Add Donation Letter"
              [(visible)]="showDonationLetterDialog"
              [modal]="true"
              [closable]="true"
              [maximizable]="true"
              draggable="false"
              styleClass="p-dialog-static p-dialog-lg fadein animation-duration-300">

      <!-- Donation Letter -->
      <form [formGroup]="donationLetterForm" *ngIf="!showAttributionTransactionFields">
        <p-card>
          <div class="formgrid grid">
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="letterType" class="required">Letter Type</label>
              <p-dropdown [options]="letterTypes"
                          formControlName="letterTypeId"
                          placeholder="Please Select"
                          optionValue="value"
                          optionLabel="text"
                          (onChange)="onLetterTypeChange($event.value)"
                          [disabled]="!!donationLetterForm.get('letterTypeId')?.disabled || isReadOnlyMode">
              </p-dropdown>
              <div class="p-error" *ngIf="donationLetterForm.get('letterTypeId')?.invalid && donationLetterForm.get('letterTypeId')?.touched">
                Letter Type is required.
              </div>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="sendDate" class="required">Send Date</label>
              <p-calendar formControlName="sendDate" [disabled]="!!donationLetterForm.get('sendDate')?.disabled || isReadOnlyMode" showIcon iconDisplay="input" dateFormat="mm/dd/yy" placeholder="MM/DD/YYY"></p-calendar>
              <div class="p-error" *ngIf="donationLetterForm.get('sendDate')?.invalid && donationLetterForm.get('sendDate')?.touched">
                Send Date is required.
              </div>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="responseDate" class="required">Response Date</label>
              <p-calendar formControlName="responseDate" [disabled]="!!donationLetterForm.get('responseDate')?.disabled || isReadOnlyMode" showIcon iconDisplay="input" dateFormat="mm/dd/yy" placeholder="MM/DD/YYY"></p-calendar>
              <div class="p-error" *ngIf="donationLetterForm.get('responseDate')?.invalid && donationLetterForm.get('responseDate')?.touched">
                Response Date is required.
              </div>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="responseAction" class="required">Response Action</label>
              <p-dropdown [options]="responseActions"
                          formControlName="responseActionId"
                          placeholder="Please Select"
                          optionValue="value"
                          optionLabel="text"
                          (onChange)="onResponseActionChange($event.value)"
                          [disabled]="isReadOnlyMode">
              </p-dropdown>
              <div class="p-error" *ngIf="errorMessage">{{ errorMessage }}</div>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="showRefundAmount">
              <div *ngIf="showRefundAmount" class="amount-remaining pt-3">
                <p><b class="red-60">Amount Remaining:</b> {{ maxRefundRemaining | currency }}</p>
              </div>

              <label for="refundAmount" class="required">Refund Amount</label>
              <input id="refundAmount"
                      type="text"
                      pInputText
                      formControlName="refundAmount"
                      class="form-control"
                      placeholder="Enter Refund Amount"
                      (input)="onAmountInput($event, 'refundAmount')"
                      [disabled]="isReadOnlyMode">
              <div *ngIf="donationLetterForm.get('refundAmount')?.hasError('refundExceedsRemaining')" class="p-error">
                Refund amount exceeds remaining amount.
              </div>
              <small class="p-error" *ngIf="donationLetterForm.get('refundAmount')?.hasError('required') && donationLetterForm.get('refundAmount')?.touched">
                Refund Amount is required.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="showPermissibleFields">
              <label for="fecLineNumber" class="required">FEC Line Number</label>
              <p-dropdown [options]="fecLineNumbers"
                          formControlName="fecLineNumberId"
                          optionValue="value"
                          optionLabel="text"
                          placeholder="Please Select"
                          [disabled]="isReadOnlyMode">
              </p-dropdown>
              <small class="p-error" *ngIf="donationLetterForm.get('fecLineNumberId')?.invalid && donationLetterForm.get('fecLineNumberId')?.touched">
                FEC Line Number is required.
              </small>
            </div>
            
            <div class="field col-12 sm:col-6 xl:col-3" *ngIf="showPermissibleFields">
              <label for="fecDescription" class="required">FEC Description</label>
              <textarea formControlName="fecDescription" pInputTextarea rows="3" class="form-control" [disabled]="isReadOnlyMode"></textarea>
              <small class="p-error" *ngIf="donationLetterForm.get('fecDescription')?.invalid && donationLetterForm.get('fecDescription')?.touched">
                FEC Description is required.
              </small>
            </div>
          
          </div>
        </p-card>

        <div class="imported-dialog-footer">
          <rc-generic-button label="Cancel" borderStyle="text-only" (click)="showDonationLetterDialog = false"/>
          <rc-generic-button [disabled]="donationLetterForm.invalid || isReadOnlyMode" label="Save" [classes]="['mx-2']" (click)="saveDonationLetter()" />
        </div>
      </form>

      <!-- Attribution Assignment -->
      <form [formGroup]="attributionTransactionForm" *ngIf="showAttributionTransactionFields">
        <p-card>
          <div class="formgrid grid top-section">
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fundCode" class="required">Fund Code</label>
              <p-autoComplete id="fundCode"
                              formControlName="fundCode" 
                              [suggestions]="fundCodeSuggestions" 
                              (completeMethod)="onFundCodeSearch($event)" 
                              (onSelect)="onFundCodeSelect($event)" 
                              placeholder="Type to Search"
                              [disabled]="isReadOnlyMode">
              </p-autoComplete>
              <small class="p-error" *ngIf="attributionTransactionForm.get('fundCode')?.invalid && attributionTransactionForm.get('fundCode')?.touched">
                Please select a fund code.
              </small>
            </div>
            
            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="amount" class="required">Amount</label>
              <input pInputText
                     type="text"
                     id="amount"
                     formControlName="amount"
                     class="form-control"
                     (input)="onAmountInput($event, 'amount', 'attributionTransactionForm')"
                     [disabled]="isReadOnlyMode"/>
              <small class="p-error" *ngIf="attributionTransactionForm.get('amount')?.invalid && attributionTransactionForm.get('amount')?.touched">
                Amount is required.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="adjustmentDate" class="required">Adjustment Date</label>
              <p-calendar id="adjustmentDate" formControlName="adjustmentDate" showIcon iconDisplay="input" dateFormat="mm/dd/yy" placeholder="MM/DD/YYY" [disabled]="isReadOnlyMode"></p-calendar>
              <small class="p-error" *ngIf="attributionTransactionForm.get('adjustmentDate')?.invalid && attributionTransactionForm.get('adjustmentDate')?.touched">
                Adjustment Date is required.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fecLineNumber" class="required">FEC Line Number</label>
              <p-dropdown id="fecLineNumber"
                          [options]="fecLineNumbers"
                          placeholder="Please Select"
                          formControlName="fecLineNumberId"
                          optionValue="value"
                          optionLabel="text"
                          [disabled]="isReadOnlyMode">
              </p-dropdown>
              <small class="p-error" *ngIf="attributionTransactionForm.get('fecLineNumberId')?.invalid && attributionTransactionForm.get('fecLineNumberId')?.touched">
                FEC Line Number is required.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="fecDescription" class="required">FEC Description</label>
              <textarea pInputTextarea id="fecDescription" formControlName="fecDescription" class="form-control" [disabled]="isReadOnlyMode"></textarea>
              <small class="p-error" *ngIf="attributionTransactionForm.get('fecDescription')?.invalid && attributionTransactionForm.get('fecDescription')?.touched">
                FEC Description is required.
              </small>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="customNote">Custom Note</label>
              <textarea pInputTextarea id="customNote" formControlName="customNote" class="form-control" [disabled]="isReadOnlyMode"></textarea>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3 pt-5">
              <p-checkbox 
                formControlName="refundExcess" 
                binary="true" 
                label="Refund excess portion of this donation" 
                (onChange)="onRefundCheckboxChange()"
                [disabled]="isReadOnlyMode">
              </p-checkbox>
            </div>

            <div class="field col-12 sm:col-6 xl:col-3">
              <label for="refundAmount" class="required">Refund Amount</label>
              <input 
                pInputText 
                type="text" 
                id="refundAmount" 
                formControlName="refundAmount" 
                class="form-control" 
                [disabled]="!attributionTransactionForm.get('refundExcess')?.value || isReadOnlyMode" 
                placeholder="$"
                (input)="onAmountInput($event, 'refundAmount', 'attributionTransactionForm')">
              <small class="text-danger" *ngIf="maxRefundRemaining > 0">
                Maximum Refund Amount: {{ maxRefundRemaining | currency }}
              </small>
              <small class="p-error" *ngIf="attributionTransactionForm.get('refundAmount')?.invalid && attributionTransactionForm.get('refundAmount')?.touched">
                Refund Amount is required and must not exceed the remaining amount.
              </small>
            </div>
          </div>
        </p-card>

        
        <div class="donor-section grid mt-3">

          <div class="donor-search col-12 xl:col-6">
            <div class="full-height p-5 bg-neutral-0">

              <div *ngIf="!selectedDonor">
                <span class="h4 block redwood-80">Attribution for:</span>
                <button type="button" pButton label="Select Donor" class="p-button p-button-secondary" (click)="onSearchDonorClick()" [disabled]="isReadOnlyMode"></button>
              </div>
              
              <div *ngIf="selectedDonor">
                <div class="mb-3 flex align-items-center gap-2">
                  <span class="h4 mb-0">Attribution for:</span> 
                  <span><b>{{ selectedDonor.firstName }} {{ selectedDonor.lastName }}</b> ({{ selectedDonor.donorId }})</span>
                  <p-button 
                    styleClass="p-button-icon-red-light"
                    icon="fa-sharp fa-light fa-circle-xmark"
                    title="Delete"
                    (onClick)="removeSelectedDonor()"
                    [disabled]="isReadOnlyMode">
                  </p-button>
                </div>

                <app-donor-fund-totals-grid [donorId]="selectedDonor.donorId"></app-donor-fund-totals-grid>
              </div>

              <div class="mt-6">
                <button pButton label="Add to Pending" class="p-button" (click)="onContinue()" [disabled]="isReadOnlyMode"></button>
              </div>

            </div>
          </div>
          

          <div class="donor-summary col-12 xl:col-6 text-center">
            <h3 class="redwood-80">Parent Donation Amount: <span class="red-60">{{ parentDonationAmount | currency }}</span></h3>
            <div class="mb-5">
              <h4>Pending Attributed Donors</h4>
              <p-table [value]="pendingAttributedDonors">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Donor ID</th>
                    <th>Name</th>
                    <th>Amount</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-donor>
                  <tr>
                    <td>{{ donor.donorId }}</td>
                    <td>{{ donor.name }}</td>
                    <td>{{ donor.amount | currency }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr>
                    <td colspan="2"><strong>Total</strong></td>
                    <td><strong>{{ pendingAttributedDonorsTotal | currency }}</strong></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            
            <div>
              <h4>Attributed Donors</h4>
              <p-table [value]="attributedDonors">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Donor ID</th>
                    <th>Name</th>
                    <th>Amount</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-donor>
                  <tr>
                    <td>{{ donor.donorId }}</td>
                    <td>{{ donor.name }}</td>
                    <td>{{ donor.amount | currency }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr>
                    <td colspan="2"><strong>Total</strong></td>
                    <td><strong>{{ attributedDonorsTotal | currency }}</strong></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <div class="imported-dialog-footer">
          <rc-generic-button label="Discard Changes + Exit" borderStyle="text-only" (click)="showDonationLetterDialog = false"/>
          <rc-generic-button [disabled]="pendingAttributedDonors.length === 0 || isReadOnlyMode" label="Apply Attributions" [classes]="['mx-2']" (click)="saveAttributionTransaction()" />
        </div>
      </form>
    </p-dialog>
</div>

<!-- Delete Donation Letter MODAL -->
<p-dialog header="Confirm Action" 
  [(visible)]="showDeleteDialog" 
  [modal]="true" 
  [closable]="false"
  styleClass="p-confirm-dialog">

  <p>Are you sure you want to delete this compliance letter?</p>
  
  <p-footer>
    <button pButton type="button" label="Cancel" class="p-button-outlined" (click)="closeDeleteDialog()"></button>
    <button pButton type="button" label="Delete" (click)="confirmDeleteLetter()" [disabled]="isReadOnlyMode"></button>
  </p-footer>
</p-dialog>


<!-- Donor Search Dialog -->
<p-dialog header="Search Donor"
          [(visible)]="showDonorSearchDialog"
          [modal]="true"
          [closable]="true"
          draggable="false"
          styleClass="p-dialog-static p-dialog-full-width fadein animation-duration-300">
  <app-donor-search
      [showInDialog]="true"
      (donorSelected)="onDonorSelected($event)"
      (cancelEvent)="hideDonorSearchDialog()"
      (closeDonorSearch)="closeDonorSearch()">
  </app-donor-search>
</p-dialog>


